import { render, staticRenderFns } from "./NoWidgetLayout.vue?vue&type=template&id=35fedf89"
import script from "./NoWidgetLayout.vue?vue&type=script&lang=js"
export * from "./NoWidgetLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports